import { FaHtml5, FaCss3, FaJs, FaNodeJs } from "react-icons/fa";
import { SiMysql, SiMongodb, SiReact, SiExpress } from "react-icons/si";

export const skillsArr = [
  { name: "HTML", icon: <FaHtml5 /> },
  { name: "CSS", icon: <FaCss3 /> },
  { name: "JS", icon: <FaJs /> },
  { name: "Node.js", icon: <FaNodeJs /> },
  { name: "SQL", icon: <SiMysql /> },
  { name: "MongoDB", icon: <SiMongodb /> },
  { name: "React", icon: <SiReact /> },
  { name: "Express", icon: <SiExpress /> },
];
